export default __webpack_public_path__ + "static/media/kidney.c2035bea.png";